import React from 'react';
import Table, { TableRow, TableCell } from '@amzn/meridian/table';

/**
 * A resusaable Table component that accepts headers and rows as prop
 * @param {*} param0
 * @returns
 */
const DynamicTable = ({ headerRows, rows, showDividers = false, collapsedRows = new Set(), onToggleRowCollapse }) => {
  return (
    <React.Fragment>
      <Table headerRows={headerRows.length} showDividers={showDividers}>
        {headerRows.map((headerRow, rowIndex) => (
          <TableRow key={`header-${rowIndex}`} highlightOnHover={false}>
            {headerRow.cells.map(({ content, colSpan, rowSpan, backgroundColor, hidden }, idx) =>
              hidden ? null : (
                <TableCell
                  key={`header-cell-${rowIndex}-${idx}`}
                  columnSpan={colSpan}
                  rowSpan={rowSpan}
                  backgroundColor={backgroundColor}>
                  {content}
                </TableCell>
              )
            )}
          </TableRow>
        ))}

        {rows.map(({ key, cells, backgroundColor, highlightOnHover }) => (
          <TableRow key={key} backgroundColor={backgroundColor} highlightOnHover={highlightOnHover}>
            {cells.map(({ content, colSpan, rowSpan, backgroundColor, hidden }, idx) =>
              hidden ? null : (
                <TableCell
                  key={`cell-${key}-${idx}`}
                  columnSpan={colSpan}
                  rowSpan={rowSpan}
                  backgroundColor={backgroundColor}>
                  {typeof content === 'function'
                    ? content({ rowKey: key, collapsedRows, onToggleRowCollapse })
                    : content}
                </TableCell>
              )
            )}
          </TableRow>
        ))}
      </Table>
    </React.Fragment>
  );
};

export default DynamicTable;
